<template>
  <div>
    <div class="pt-6 px-4 bg-white" style="height: calc(100vh - 3rem);">
      <div class="flex flex-row items-center justify-between">
        <div class="flex flex-col leading-normal">
          <p class="text-grey">{{ uploadedBy }}</p>
          <p class="text-grey-darker font-semibold">{{ uploadedOn }}</p>
        </div>
      </div>

      <div class="bg-grey-extralight rounded mt-4 test">
        <div class="flex flex-row items-center justify-between border-b pt-2 pb-1">
          <div class="flex flex-row items-center">
            <!-- v-bind:class="[activeResults === 'results' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer ml-2 mt-2 mr-4" -->
            <p class="font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2":class="showTab === 'results' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue'"@click="showTab = 'results'">RESULTS</p>
            <p class="font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2":class="showTab === 'notes' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue'"@click="showTab = 'notes'">NOTES</p>
            <p class="font-semibold text-sm tracking-wide cursor-pointer text-center px-4 py-2":class="showTab === 'reports' ? 'text-blue border-solid border-b border-blue' : 'text-grey hover:text-blue'"@click="showTab = 'reports'">REPORTS</p>
          </div>
        </div>

        <!-- Results Tab -->
        <div v-show="showTab == 'results'">
          <div v-if="data.digitized_reports && data.digitized_reports.length">
            <div class="overflow-y-scroll reports-scroll">
              <div v-for="report in data.digitized_reports" :key="report.lab_test_id" class="flex flex-col px-4  text-grey-darker">
                <p class="font-semibold text-base pt-2">{{ report.name ? report.name : 'No reports'}}</p>
                <div v-for="result in report.results" :key="result.id" class="text-grey flex flex-row justify-between overflow-y-auto" style="color: #324467">
                  <p class="pb-3 px-2 text-sm pt-2">{{ result.test_component_name }}</p>
                  <div :class="result.color" class="pb-3 px-2 text-sm">{{result.result}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Notes Tab -->
        <div v-show="showTab == 'notes'">
          <div v-if="data.notes && data.notes.length">
            <div class="max-h-48 overflow-y-scroll reports-scroll">
              <div
                v-for="note in data.notes"
                :key="note.id"
                class="flex flex-col py-3 px-4 text-sm text-grey-darker"
              >
                <p class="text-grey-darker font-semibold">{{ note.title }}</p>
                <p class="pt-2 text-sm pl-2">{{ note.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div v-show="showTab == 'reports'">
          <div v-if="data.reports && data.reports.length">
            <div class="max-h-48 overflow-y-scroll reports-scroll">
              <div
                v-for="report in data.reports"
                :key="report.id"
                class="p-2 font-semibold text-sm text-blue cursor-pointer"
                @click="openReport(report.url)"
              >
                {{ report.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Reports State -->
    <div v-if="!data.digitized_reports.length && !data.notes.length && !data.reports.length" class="text-center text-grey-darker font-semibold text-lg pt-2">
      No Reports
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        showTab: 'results',
        uploadedBy: this.data.reports[0].uploaded_by,
        uploadedOn: this.data.reports[0].updated_at
      }
    },
    methods: {
      openReport (url) {
        window.open(url, '_blank')
      }
    }
  }
</script>


<style scoped>
.reports-scroll::-webkit-scrollbar {
  width: 4px;
}
.reports-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/PatientTests.vue